<template>
    <b-modal size="lg" :visible="visible" no-close-on-backdrop no-close-on-esc centered>
        <div slot="modal-header" class="w-100">
            <h5>Patient Note (will display on estimate)<button type="button" class="close"
                                      @click.prevent="closeModal()">
                <span aria-hidden="true">&times;</span></button>
            </h5>
        </div>
        <b-form>
            <div class="container-fluid">
                <div class="row justify-content-center m-2">
                    <div class="alert alert-danger col" role="alert" v-show="generalErrorMessage">
                        <div>{{ generalErrorMessage }}</div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-2">
                    </div>
                    <div class="col-8">
                      <b-textarea v-model="currentNotes" @input="estimateChanged = true"></b-textarea>
                    </div>
                </div>
            </div>
        </b-form>
        <div slot="modal-footer" class="w-100">
            <button type="button" class="btn btn-orange float-right" @click.prevent="saveNotes()"><font-awesome-icon size="lg" class="mr-2" v-show="isSaving" icon="spinner"  pulse/>Save</button>
            <button type="button" class="btn btn-outline-orange mr-2 float-right" @click.prevent="closeModal()">Close</button>
        </div>
    </b-modal>
</template>

<script>
/* eslint-disable vue/no-mutating-props */
  import api from '../services/api'
  import ErrorsMixin from '../mixins/ErrorsMixin'
  import AnalyticsMixin from '@/mixins/AnalyticsMixin'

  export default {
    name: 'EstimateNotesModal',

    components: { },

    mixins: [ErrorsMixin, AnalyticsMixin],

    props: {
      visible: {
        type: Boolean,
        required: true
      },

      estimate: {
        type: Object,
        required: true
      }
    },

    data () {
      return {
        isSaving: false,
        currentNotes: ''
      }
    },

    watch: {
      estimate (newValue, oldValue) {
        this.currentNotes = newValue.estimateNote
      },
      visible (newValue) {
        this.currentNotes = this.estimate.estimateNote
      }
    },

    computed: {
    },

    methods: {
      numberFromString (value) {
        if (value) {
          value = value.replace(',', '')
          return Number.parseFloat(value)
        }

        return 0
      },
      saveNotes () {
        if (this.isSaving) {
          return
        }

        this.clearAllErrors()
        this.isSaving = true

        if (typeof this.estimate.depositAmount !== 'number') {
          this.estimate.depositAmount = this.numberFromString(this.estimate.depositAmount)
        }

        this.estimate.estimateNote = this.currentNotes
        this.estimate.quickSave = true

        api.post('/Dashboard/Estimate/' + this.estimate.organizationPatientEstimateId, this.estimate, { timeout: 120000 }).then(response => {
          this.trackEvent(this.$options.name, 'NoteSave', 'ResponseTime', response.config.requestDuration)

          this.$emit('noteProcessed', response.data)
          this.closeModal()
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.$store.logErrorResponse(this.$options.name, 'SaveError', error)
            if (error.response && error.response.data) {
              this.setErrorsFromResponse(error.response.data)
            } else {
              this.addErrorForField('exception', error.message)
            }
            this.$log.error('Error attempting to save estimate: ' + error.message, error)
          }
        }).then(() => {
          // always executed
          this.isSaving = false
          this.estimate.quickSave = false
        })

      },

      closeModal () {
        this.$emit('update:visible', false)
      }
    }
  }
</script>

<style scoped>

</style>
